import { HttpInterceptorFn } from '@angular/common/http';
import {ACCESS_TOKEN_KEY} from '../models/storageKeys';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const token = sessionStorage.getItem(ACCESS_TOKEN_KEY) ?? '';
  request = request.clone({
    setHeaders: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });

  return next(request);
};
